import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from 'app/Shared/Component/footer/footer.component';
import { NavbarComponent } from 'app/Shared/Component/navbar/navbar.component';
import { OrderViewerComponent } from 'app/Shared/Component/order-viewer/order-viewer.component';
import { ButtonModule } from 'primeng/button';
import { ODROrderViewerComponent } from './odr/odr-order-viewer/odr-order-viewer.component';

@Component({
    styles: [`
  `],
    selector: 'app-pages',
    imports: [RouterModule, FooterComponent, NavbarComponent, ButtonModule, OrderViewerComponent,ODROrderViewerComponent],
    providers: [],
    template: `
  <div  class="main-container">
  <div class="sub-container">

  <header class="header">
      <app-navbar ></app-navbar> 
    </header>

    <!-- Order Details Code-->
    <app-order-viewer> </app-order-viewer> 
    <app-odr-order-viewer> </app-odr-order-viewer> 

  <router-outlet> </router-outlet>

  </div>
  <br>
  <footer class="footer">
    <app-footer></app-footer>
  </footer>
 </div>
 
`
})
export class PagesComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}



